module.exports = __webpack_public_path__ + "static/media/DJ.6da4ceaf.svg";